import { render, staticRenderFns } from "./test2View.vue?vue&type=template&id=d038f58c&scoped=true"
import script from "./test2View.vue?vue&type=script&lang=js"
export * from "./test2View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d038f58c",
  null
  
)

export default component.exports